module.exports = __webpack_public_path__ + "img/variations.50e297c.webp";